import { render, staticRenderFns } from "./iFrameShow.vue?vue&type=template&id=d0ef7de6&scoped=true"
import script from "./iFrameShow.vue?vue&type=script&lang=js"
export * from "./iFrameShow.vue?vue&type=script&lang=js"
import style0 from "./iFrameShow.vue?vue&type=style&index=0&id=d0ef7de6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ef7de6",
  null
  
)

export default component.exports